import {AssetSolarWithdrawalOptionPutDataTransferObject} from "../../data-transfer-object/asset/AssetSolarWithdrawalOptionPutDataTransferObject"

/**
 * 솔라 인출 옵션 속성 설명
 */
export const AssetSolarWithdrawalOptionPutDataTransferObjectDescription: Record<keyof AssetSolarWithdrawalOptionPutDataTransferObject, string> = {
    solarAmount: '차감 솔라',
    cashAmount: '지급 금액'
}
